import { mails, storyEvents } from "../data/generated";
import type { GameState, StoryCondition, StoryEvent } from "../types";
import { createNormalMail } from "./anomalyEngine";
import type { GeneratedMail, MailTemplate } from "../types";

function conditionMatches(condition: StoryCondition, state: GameState): boolean {
  if (condition.phase && condition.phase !== state.phase) return false;
  if (condition.minProgress !== undefined && state.progress < condition.minProgress) return false;
  if (condition.maxProgress !== undefined && state.progress > condition.maxProgress) return false;
  if (condition.minLoopCount !== undefined && state.loopCount < condition.minLoopCount) return false;
  if (condition.maxLoopCount !== undefined && state.loopCount > condition.maxLoopCount) return false;
  if (condition.currentMailIndex !== undefined && state.currentMailIndex !== condition.currentMailIndex) return false;
  if ((condition.requiredFlags ?? []).some((flag) => !state.flags[flag])) return false;
  if ((condition.excludedFlags ?? []).some((flag) => state.flags[flag])) return false;
  return true;
}

export function findPendingStoryEvent(state: GameState): StoryEvent | undefined {
  return storyEvents
    .filter((event) => !event.oncePerRun || !state.triggeredStoryEventIds.includes(event.id))
    .filter((event) => conditionMatches(event.condition, state))
    .sort((a, b) => b.priority - a.priority)[0];
}

function createStoryMail(mail: MailTemplate): GeneratedMail {
  const generated = createNormalMail(mail);
  if (!mail.tags.includes("retired") && !mail.tags.includes("meta")) return generated;
  return {
    ...generated,
    isAnomaly: true,
    anomalyType: mail.senderId === "yamada" ? "retired_sender" : "retired_cc",
    debugExplanation: mail.senderId === "yamada"
      ? "退職済み社員の停止済みアカウントから送信されている。"
      : "退職済み社員が宛先またはCCに含まれている。"
  };
}

export function applyStoryEvent(state: GameState, event: StoryEvent): GameState {
  const action = event.action;
  const forced = action.forceMailId ? mails.find((mail) => mail.id === action.forceMailId) : undefined;

  return {
    ...state,
    currentMail: forced ? createStoryMail(forced) : state.currentMail,
    triggeredStoryEventIds: [...state.triggeredStoryEventIds, event.id],
    portalMutationIds: [...new Set([...state.portalMutationIds, ...(action.addPortalMutationIds ?? [])])],
    manualMutationIds: [...new Set([...state.manualMutationIds, ...(action.addManualMutationIds ?? [])])],
    directoryMutationIds: [...new Set([...state.directoryMutationIds, ...(action.addDirectoryMutationIds ?? [])])],
    flags: { ...state.flags, ...(action.setFlags ?? {}) }
  };
}
